import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { Tab, Tabs } from "react-bootstrap";
import "./PaneledTabs.scss";

const propTypes = {
  /**
   * Single tab containing title, eventKey and content.
   * Also accepts subTabs.
   */
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      eventKey: PropTypes.string.isRequired,
      title: PropTypes.node.isRequired,
      content: PropTypes.node,
      subTabs: PropTypes.arrayOf(
        PropTypes.shape({
          eventKey: PropTypes.string.isRequired,
          title: PropTypes.node.isRequired
        })
      )
    })
  ),
  /**
   * Key of the selected tab
   */
  activeKey: PropTypes.string.isRequired,
  /**
   * Callback for when the tab gets selected
   */
  onSelect: PropTypes.func.isRequired,
  /**
   * Optional className on the root wrapper (e.g. BEM modifier for page-specific tab sizing).
   */
  className: PropTypes.string
};





/**
 * Tabs with a content panel that accepts sub tabs.
 * Page content has to be rendered based on the selected `activeKey`.
 * Based on https://react-bootstrap-v4.netlify.app/components/tabs/.
 */
function PaneledTabs(props) {
  const { tabs = [], activeKey, onSelect, className = null, ...tabsProps } = props ?? {};

  const [tabActiveKey, subTabActiveKey] = activeKey.split(".");

  return (
    <div className={clsx("Uic-PaneledTabs-base", "mb-4", className)}>
      <Tabs
        className={clsx("Uic-PaneledTabs-multi", "p-0")}
        activeKey={tabActiveKey}
        onSelect={onSelect}
        {...tabsProps}>

        {tabs.map(({ eventKey, title, content, subTabs, ...tabProps }) =>
        <Tab
          key={eventKey}
          eventKey={eventKey}
          title={<h5>{title}</h5>}
          {...tabProps}>

            {content}
            {subTabs &&
          <SubTabs
            subTabs={subTabs}
            onSelect={onSelect}
            tabActiveKey={tabActiveKey}
            subTabActiveKey={subTabActiveKey} />

          }
          </Tab>
        )}
      </Tabs>
    </div>);

}

// disabling proptypes on the sub components below
// since they are already documented on the main component
/* eslint-disable react/prop-types */
function SubTabs(props) {
  const { subTabs, onSelect, tabActiveKey, subTabActiveKey } = props;

  return (
    <div className="Uic-PaneledTabs-subTabs">
      <Tabs
        activeKey={subTabActiveKey}
        onSelect={(key) => onSelect(`${tabActiveKey}.${key}`)}
        className="Uic-PaneledTabs-subNav p-0">

        {subTabs.map(({ eventKey, title, ...subTabProps }) =>
        <Tab
          key={eventKey}
          eventKey={eventKey}
          title={
          <p className={clsx("Uic-PaneledTabs-subTabTitle", "font-bolder")}>
                {title}
              </p>
          }
          {...subTabProps} />

        )}
      </Tabs>
    </div>);

}

PaneledTabs.propTypes = propTypes;


export default PaneledTabs;
